import React from 'react';
import img from '../../assets/coordinadora_chat.png'
import { Box, withStyles, WithStyles } from '@material-ui/core';
import { imgCoordinadoraStyles } from "../../styles";

interface imgCoordinadoraProp extends WithStyles<typeof imgCoordinadoraStyles> {
    children?: React.ReactNode;
    className?: string;
}
export const ImgCoordinadoraComponent = ({classes}:imgCoordinadoraProp) : JSX.Element => {
    return (
        <Box display="flex" justifyContent="center" paddingBottom="5%" borderBottom="1px solid #DDDDDD" width="100%">
            <img className={classes.img} src={img} alt=""/>
        </Box>
    )
}

export const ImgCoordinadora = withStyles(imgCoordinadoraStyles)(ImgCoordinadoraComponent);